import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        // background: 'linear-gradient(180deg, #000000 37.95%, #362F78 100%)',
        background: '#141329',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.up('lg')]: {
            paddingTop: 32
        },
        [theme.breakpoints.down('md')]: {
            padding: '0px 24px',
        }
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '1366px',
    },
    textSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        margin: 0,
        fontSize: '48px',
        fontWeight: '800',
        color: '#fff',
        lineHeight: '58px',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: '30px',
            lineHeight: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: 28
        }
    },
    gradientText: {
        background: "linear-gradient(to right, #1B7AED 0%, #9048D8 70%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        backgroundClip: "text",
        textFillColor: "transparent",
    },
    description: {
        fontSize: '24px',
        fontWeight: '500',
        color: '#fff',
        marginTop: 16,
        marginBottom: 32,
        [theme.breakpoints.down('md')]: {
            fontSize: '18px',
            lineHeight: '30px',
            textAlign: 'center',
            marginBottom: 24,
        }
    },
    ctaButton: {
        background: '#667eea',
        border: 'none',
        borderRadius: '50px',
        padding: '20px 40px',
        fontSize: '20px',
        fontWeight: '700',
        color: '#fff',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        marginBottom: '20px',
        display: 'block',
        width: 'fit-content',
        margin: '0 auto 20px auto',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 10px 25px rgba(102, 126, 234, 0.4)',
        }
    },
    disclaimer: {
        background: '#CCD0FF',
        borderRadius: 12,
        padding: '16px 24px',
        marginTop: 64,
        fontSize: 16,
        fontWeight: 700,
        color: '#403DE3',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            marginTop: 32,
        }
    },
    imageSection: {
        flex: '1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 32,
        [theme.breakpoints.down('md')]: {
            marginTop: 24,
        }
    },
    appImage: {
        maxWidth: '301px',
        height: 'auto',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '250px',
        }
    },
    mobileBreak: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    desktopBreak: {
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
}));

export default useStyles;
